import { useTranslation } from 'react-i18next';
import { Car, Bus, Navigation, ParkingCircle } from 'lucide-react';

export default function TransportationPage() {
  const { t } = useTranslation();

  const sections = [
    {
      key: 'driving',
      icon: Car,
      content: [
        { label: t('transportation.fromTaipei'), text: '國道3號 → 關西交流道 → 台3線 → 竹120縣道 → 尖石鄉（約2小時）' },
        { label: t('transportation.fromHsinchu'), text: '台68線快速道路 → 竹120縣道 → 尖石鄉（約1小時）' },
      ],
    },
    {
      key: 'publicTransit',
      icon: Bus,
      content: [
        { label: '高鐵新竹站', text: '搭乘新竹客運往尖石方向，於尖石站下車（約1.5小時）' },
        { label: '台鐵新竹站', text: '搭乘新竹客運往尖石方向，於尖石站下車（約2小時）' },
      ],
    },
    {
      key: 'shuttle',
      icon: Navigation,
      content: [
        { label: t('transportation.shuttleSchedule'), text: '大會提供高鐵新竹站↔尖石鄉公所來回接駁車，每小時一班次。\n6月3日：07:00–10:00\n6月5日：15:00–19:00' },
      ],
    },
    {
      key: 'parking',
      icon: ParkingCircle,
      content: [
        { label: '尖石鄉公所停車場', text: '免費停車，約100個車位' },
        { label: '尖石國中操場', text: '賽事期間開放臨時停車' },
      ],
    },
  ];

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="section-title">{t('transportation.title')}</h1>
      <p className="section-subtitle">{t('transportation.subtitle')}</p>

      <div className="space-y-8">
        {sections.map((section) => (
          <div key={section.key} className="card">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                <section.icon className="w-5 h-5 text-primary" />
              </div>
              <h2 className="text-xl font-bold">
                {t(`transportation.${section.key}` as 'transportation.driving')}
              </h2>
            </div>
            <div className="space-y-4">
              {section.content.map((item, idx) => (
                <div key={idx} className="pl-4 border-l-2 border-primary/20">
                  <h3 className="font-medium mb-1">{item.label}</h3>
                  <p className="text-text-secondary text-sm whitespace-pre-line">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
